module.exports = __webpack_public_path__ + "static/media/ex-blog-posts.e1e34a0c.jpg";